import { Component, Directive } from '@angular/core';

@Directive({
    selector:
    'wep-page-tpl-login-default-heading, ' +
    'wep-page-tpl-login-default-content'
})
export class LoginDefaultPageTemplateDirective { }

@Component({
    selector: 'wep-page-tpl-login-default',
    templateUrl: './pageTemplateDefault.html',
    host: {'class': 'page-tpl page-tpl--login page-tpl--login--default'},
    styleUrls: ['./pageTemplateDefault.scss']
})

export class LoginDefaultPageTemplateComponent {

    public awthLogoPath:string = require('~/assets/images/templates/login/awth-logo-strapline.png');
}